export const number = {
  /**
   * Test if a value is numeric.
   * @param value
   * @return {Boolean}
   */
  isNumeric(value) {
    // taken from jquery
    return !isNaN(parseFloat(value)) && isFinite(value);
  },

  /**
   * Rounds to the specified number of decimal places.
   * @param {Number} num
   * @param numDecimals
   * @return {Number}
   */
  roundTo(num, numDecimals) {
    let power, rounded;

    power = Math.pow(10, numDecimals);
    rounded = Math.round(num * power) / power;

    return rounded;
  },

  /**
   * Returns an object with the number of place and decimal values.
   * @see https://stackoverflow.com/questions/27082377/get-number-of-decimal-places-with-javascript
   * @param {Number} num
   * @return {Object}
   */
  getPlaces(value) {
    let numDecimal, text = value.toString();
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf('e-') > -1) {
      let [base, trail] = text.split('e-');
      numDecimal = parseInt(trail, 10);
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== value) {
      numDecimal = value.toString().split('.')[1].length || 0;
    }

    return numDecimal;
  },

  /**
   * Return the larger absolute number.
   * @param {Number} val1
   * @param {Number} val2
   * @return {*|number}
   */
  absMax(val1, val2) {
    return Math.abs(val2) > Math.abs(val1) ? Math.abs(val2) : Math.abs(val1);
  }
};